export const VALID_LOCATIONS = [
  'Arlington', 'Atlanta', 'Austin', 'Boston', 'Chicago',
  'Dallas', 'Denver', 'Irvine', 'Miami', 'New York',
  'San Francisco', 'Santa Monica', 'Seattle', 'Other'
] as const;

export type LocationPreference = typeof VALID_LOCATIONS[number];

export interface CareerGoalsPreferences {
  id: string;
  alias: string;
  location_preference_1: LocationPreference | null;
  location_preference_2: LocationPreference | null;
  location_preference_3: LocationPreference | null;
  location_preference_notes: string | null;
  team_or_technology_alignment_interest: string | null;
  career_goals: string | null;
}

export const EXIT_DESCRIPTIONS = [
  'Attrition', 'AGS Tech Progression - Programatic',
  'AGS Tech Progression - Organic', 'Other'
] as const;

export const EXIT_DESTINATION_GEOS = ['API', 'EMEA', 'LATAM', 'NAMER'] as const;

export const EXIT_DESTINATION_TEAMS = [
  'AGS Tech - Industries', 'AGS Tech - Segments', 'PACE', 'AI-DLC',
  'Startups', 'ProServ', 'SUP', 'Other Amazon'
] as const;

export const RECOMMENDED_PLACEMENTS = [
  'AGS Tech - Industries', 'AGS Tech - Segments', 'PACE', 'AI-DLC',
  'Startups', 'ProServ', 'SUP'
] as const;

export const EARLY_CAREER_PROGRAMS = [
  'University Hire', 'Industry Hire', 're-Skill', 'TTP', 'MVP', 'Other'
] as const;

export interface CareerProfile {
  id: string;
  alias: string;
  manager_alias: string;
  tech_lead: boolean;
  exit_elig_date: string | null;
  exit_description: string | null;
  exit_destination_geo: string | null;
  exit_destination_team: string | null;
}

export interface EarlyCareerTalent {
  id: string;
  alias: string;
  manager_alias: string;
  eligible_to_progress_to_field: string | null;
  residency_progression_readiness_date: string | null;
  actual_residency_progression_date: string | null;
  recommended_placement: string | null;
  early_career_program: string | null;
  interesting: boolean;
  ect_start_date: string | null;
}

export interface DirectReport {
  alias: string;
  name: string;
  region: string;
  level: string;
  location: string;
  role: string;
  tenure: string;
  photoUrl?: string;
}
